import { useCallback } from 'react';
import { useRecoilState } from 'recoil';

import { ldlPlaylistState } from '@store';

import { ldlPlaylist } from '../components/lowerDisplayLine/LDLBase/ldlPlaylist';

const numberOfProducts = ldlPlaylist.length;

export const useShowNextLDLProduct = () => {
  const [{ activeProductIndex, isAnimationEnabled }, setPlaylistState] = useRecoilState(ldlPlaylistState);

  return useCallback(
    (force = false) => {
      if (isAnimationEnabled || force) {
        const nextProductIndex = (activeProductIndex + 1) % numberOfProducts;

        setPlaylistState(oldState => ({
          ...oldState,
          nextProductIndex,
        }));
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeProductIndex, isAnimationEnabled],
  );
};
